module.exports = __webpack_public_path__ + "img/3.82c06586.jpg";